import axios from "axios";

const axiosApiInstance = axios.create();
// const httpEndpoint = "http://59.148.100.40:8001";
let httpEndpoint = `${process.env.REACT_APP_BACKEND_ENDPOINT}`;
if (process.env.REACT_APP_BACKEND_PORT.length > 0) {
  httpEndpoint += `:${process.env.REACT_APP_BACKEND_PORT}`;
}
let wsEndpoint = `${process.env.REACT_APP_BACKEND_ENDPOINT}`;
if (process.env.REACT_APP_BACKEND_PORT.length > 0) {
  wsEndpoint += `:${process.env.REACT_APP_BACKEND_PORT}`;
}

// Request interceptor for API calls
axiosApiInstance.interceptors.request.use(
  async (config) => {
    config.headers = {
      //   Authorization: `Bearer ${getAccessToken()}`,
      Accept: "application/json",
      // "Content-Type": "application/x-www-form-urlencoded",
      "Content-Type": "application/json",
    };
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

// Response interceptor for API calls
axiosApiInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      //   const accessToken = await refreshAccessToken(getAccessToken());
      //   console.log("accessToken");
      //   console.log(accessToken);
      //   axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
      return axiosApiInstance(originalRequest);
    }
    return Promise.reject(error);
  }
);

const getFaiChunsAPI = async ({ roomId }) => {
  const response = axiosApiInstance.get(
    `${httpEndpoint}/api/v1/room/fai_chuns`,
    {
      params: { room_id: roomId },
    }
  );
  return (await response).data;
};

const resetFaiChunsAPI = async ({ roomId }) => {
  const response = axiosApiInstance.get(
    `${httpEndpoint}/api/v1/room/reset_fai_chun`,
    {
      params: { room_id: roomId },
    }
  );
  return (await response).data;
};

const sendFaiChunAPI = async ({ roomId, dataURL }) => {
  const response = axiosApiInstance.post(
    `${httpEndpoint}/api/v1/room/fai_chun`,
    {
      room_id: roomId,
      data_url: dataURL,
    }
  );
  return (await response).data;
};

const sendEmojiAPI = async ({ roomId, alt }) => {
  const response = axiosApiInstance.post(
    `${httpEndpoint}/api/v1/room/send_emoji`,
    {
      room_id: roomId,
      emoji_key: alt,
    }
  );
  return (await response).data;
};

const createRoomAPI = async ({ roomId }) => {
  const response = axiosApiInstance.post(
    `${httpEndpoint}/api/v1/room/create_room`,
    { room_id: roomId }
  );
  return (await response).data;
};

const checkRoomExistAPI = async ({ roomId }) => {
  const response = axiosApiInstance.get(
    `${httpEndpoint}/api/v1/room/check_room_exist`,
    {
      params: { room_id: roomId },
    }
  );
  return (await response).data;
};

const getAudio = async ({ uid }) => {
  const audio = new Audio(`${httpEndpoint}/api/v1/project/audio?uid=${uid}`);
  return await audio;
};

export {
  checkRoomExistAPI,
  createRoomAPI,
  getFaiChunsAPI,
  getAudio,
  resetFaiChunsAPI,
  sendFaiChunAPI,
  sendEmojiAPI,
  wsEndpoint,
};
